import { render, staticRenderFns } from "./OnePager.vue?vue&type=template&id=2d963248&"
import script from "./OnePager.vue?vue&type=script&lang=js&"
export * from "./OnePager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports